module.exports = __webpack_public_path__ + "static/media/banner_box_circle-red.ae796273.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/HomePage/blocks/FlavourBlock/banner_box_circle-red.jpg
// module id = 246
// module chunks = 0